module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-Kreis_red-5a4f10c7f9fb2046cdaeaa527e4a6ed9.svg";